import { render } from "./chartComponentArchive.vue?vue&type=template&id=570b5adb&scoped=true"
import script from "./chartComponentArchive.vue?vue&type=script&lang=js"
export * from "./chartComponentArchive.vue?vue&type=script&lang=js"

import "./chartComponentArchive.vue?vue&type=style&index=0&id=570b5adb&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570b5adb"]])

export default __exports__